module.exports = __webpack_public_path__ + "static/media/desayuno.3cd6c6e9.svg";